<template>
  <div class="login-wrap">
    <div class="back-wrap" @click="toHome">继续查询</div>
    <div class="login">
      <div class="login-top">
        <div>考培成绩查询结果公示</div>
      </div>
      <div class="login-bottom">
        <table border="1">
          <tr>
            <td>基本信息</td>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td>姓<span style="width: 36px;display: inline-block;"></span>名</td>
            <td v-if="dataInfo.student_info">{{ dataInfo.student_info.name }}</td>
            <td>性<span style="width: 36px;display: inline-block;"></span>别</td>
            <td v-if="dataInfo.student_info">{{ dataInfo.student_info.sex == 1 ? '男' : '女' }}</td>
          </tr>
          <tr>
            <td>身份证号</td>
            <td v-if="dataInfo.student_info">{{ dataInfo.student_info.idcard }}</td>
            <td>学<span style="width: 36px;display: inline-block;"></span>号</td>
            <td>{{ xuehao }}</td>
          </tr>
          <tr>
            <td>考培结果公示</td>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td>参考专业</td>
            <td colspan="3">{{ dataInfo.major_name }}</td>
          </tr>
          <tr>
            <td>卷面总分</td>
            <td>{{ Number(dataInfo.score).toFixed(0) }}分</td>
            <td>考试得分</td>
            <td>{{ Number(dataInfo.total_score).toFixed(0) }}分</td>
          </tr>
          <tr>
            <td>考试方式</td>
            <td colspan="3">线上考试</td>
          </tr>
          <tr>
            <td>考试结果</td>
            <td colspan="3">{{ hege }}</td>
          </tr>
          <tr>
            <td>考试时间</td>
            <td colspan="3">{{ formatTimestamp(dataInfo.end_time) }}</td>
          </tr>
          <tr>
            <td>下载查询</td>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td colspan="4">
              <div class="bottom">
                <td @click="toPage(1)">在线培训学习课程大纲</td>
                <td @click="toPage(2)">在线测评考试试卷查阅</td>
                <td @click="toPage(3)">考培学时证明下载</td>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import {find_chengji} from "../api";

export default {
  name: "login",
  data() {
    return {
      idCard: '',
      password: '',
      xuehao: '',
      dataInfo: {},
      hege: '',
      end_time: '',
      logoSrc:require('@/assets/images/zxx.png'),
      logoSrc1:require('@/assets/images/logo2.png'),
    }
  },
  mounted() {
    this.xuehao = this.$route.query.xuehao
    this.getInfo()
  },
  methods: {
    getInfo() {
      let ajaxData = {
        xuehao: this.xuehao
      }
      find_chengji(ajaxData).then(res => {
        if (res.code == 1) {
          console.log(res.data)
          this.dataInfo = res.data[0]

          if (Number(this.dataInfo.score) * 0.6 > Number(this.dataInfo.total_score)) {
            this.hege = '不合格'
          } else {
            this.hege = '合格'
          }

        } else {
          this.$message.error(res.msg)
        }
      })
    },
    toHome() {
      this.$router.push({
        path: '/login?type=3'
      })
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 获取月份并确保是两位数
      const day = ('0' + date.getDate()).slice(-2); // 获取日期并确保是两位数
      return `${year}年${month}月${day}日`;
    },
    async toPage(num){
      let subject_id =  this.dataInfo.subject_id
      let hege =  this.hege
      let student_id =  this.dataInfo.student_id
      let major_id =  this.dataInfo.major_id
      let shijuan_id =  this.dataInfo.shijuan_id
      let info1 = {
        subject_id,
        hege
      }
      let info2 = {
        student_id,
        major_id,
        shijuan_id,
      }
      this.generateQRCode(subject_id,hege)
      this.generateQRCode1(student_id,major_id,shijuan_id)

      if (num == 1) {
        this.$router.push({
          path: '/mycourseDetail',
          query: {xuehao:this.xuehao},
        })
      }else if (num == 2){
        this.$router.push({
          path: '/chengji',
          query: {xuehao:this.xuehao},
        })
      }else if (num == 3){
        this.$router.push({
          path: '/proof',
          query: {info:JSON.stringify(info2)},
        })
      }
    },
    async generateQRCode(subject_id,hege){
      let url = 'https://www.rsx.org.cn/mycourseDetail?xuehao=' + this.xuehao

      try {
        // 使用 qrcode 生成二维码并获取Data URL
        const qrDataURL = await QRCode.toDataURL(url, {
          errorCorrectionLevel: 'H', // 设置较高的容错级别
          width: 300,
        });

        // 合并二维码与Logo
        if (this.dataInfo.student_info.is_muban == 1){
          let qrCodeUrl = await this.mergeLogoWithQRCode(qrDataURL, this.logoSrc);
          localStorage.setItem('url', qrCodeUrl);
        }else {
          let qrCodeUrl = await this.mergeLogoWithQRCode(qrDataURL, this.logoSrc1);
          localStorage.setItem('url', qrCodeUrl);
        }

      } catch (err) {
        console.error('生成二维码失败:', err);
      }
    },
    async generateQRCode1(student_id,major_id,shijuan_id){
      let url = 'https://www.rsx.org.cn/chengji?xuehao=' + this.xuehao

      try {
        // 使用 qrcode 生成二维码并获取Data URL
        const qrDataURL = await QRCode.toDataURL(url, {
          errorCorrectionLevel: 'H', // 设置较高的容错级别
          width: 300,
        });

        // 合并二维码与Logo
        if (this.dataInfo.student_info.is_muban == 1){
          let qrCodeUrl = await this.mergeLogoWithQRCode(qrDataURL, this.logoSrc);
          localStorage.setItem('url1', qrCodeUrl);
        }else {
          let qrCodeUrl = await this.mergeLogoWithQRCode(qrDataURL, this.logoSrc1);
          localStorage.setItem('url1', qrCodeUrl);
        }
      } catch (err) {
        console.error('生成二维码失败:', err);
      }
    },
    async mergeLogoWithQRCode(qrDataURL, logoSrc) {
      return new Promise((resolve, reject) => {
        const imgQr = new Image();
        imgQr.src = qrDataURL;
        imgQr.onload = () => {
          const imgLogo = new Image();
          imgLogo.src = logoSrc;
          imgLogo.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const qrSize = 300; // 二维码尺寸
            const logoSize = qrSize * 0.25; // Logo大小为二维码的25%

            // 设置canvas尺寸
            canvas.width = qrSize;
            canvas.height = qrSize;

            // 绘制二维码
            ctx.drawImage(imgQr, 0, 0, qrSize, qrSize);

            // 计算Logo绘制位置
            const x = (qrSize - logoSize) / 2;
            const y = (qrSize - logoSize) / 2;

            // 可选：绘制白色背景或圆形遮罩
            ctx.fillStyle = 'white';
            ctx.globalAlpha = 0.8; // 调整透明度以适应需求
            ctx.fillRect(x, y, logoSize, logoSize);
            ctx.globalAlpha = 1;

            // 绘制Logo
            ctx.drawImage(imgLogo, x, y, logoSize, logoSize);

            // 返回合并后的二维码图像数据URL
            resolve(canvas.toDataURL('image/png'));
          };
          imgLogo.onerror = reject;
        };
        imgQr.onerror = reject;
      });
    }
  }
}
</script>

<style scoped lang="scss">
.login-wrap {
  background-image: url("../assets/images/login_bj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 80px 0;

  .back-wrap {
    cursor: pointer;
    position: absolute;
    right: 50px;
    top: 30px;
    padding: 10px 30px;
    border-radius: 20px;
    border: 1px solid #fff;
    color: #fff;
  }

  .login {
    width: 750px;

    .login-top {
      div {
        font-size: 30px;
        text-align: center;
        font-weight: bold;
        font-size: 30px;
        color: #fff;
        margin-bottom: 50px;
        letter-spacing: 3px;
      }
    }

    .login-bottom {
      border-radius: 0 0 15px 15px;

      .title {
        th {
          padding-left: 20px;
        }
      }

      .bottom {
        width: 100%;
        height: 64px;

        td {
          cursor: pointer;
          font-size: 16px !important;
          height: 64px !important;
          text-decoration: underline;
          line-height: 64px;
          border-right: 1px solid #000;
          border-top: 0;
          border-bottom: 0;
          border-left: 0;
          width: 299px !important;

          &:last-child {
            border-right: none;
          }
        }
      }

      table {
        width: 100%;
        background-color: #1c839c;
        border: 1px solid #222;
        color: #fff;

        tr {
          height: 64px;
        }

        th {
          font-size: 24px;
          font-weight: bold;
        }

        tr {
          td {

          }

          td:nth-child(1), td:nth-child(3) {
            text-align: center;
            font-size: 20px;
            //font-weight: bold;
            width: 22%;
          }

          td:nth-child(2), td:nth-child(4) {
            font-size: 17px;
            padding-left: 20px;
            box-sizing: border-box;
            width: 28%;
          }
        }
      }
    }
  }
}
</style>
